import React, { useState, useRef, useEffect } from 'react'
import Ending from './Ending';
import { motion } from 'framer-motion';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';


function Game({quizz, handlingRestart, easy}) {
    const leQuizz = quizz;
    const facile = easy;
    const [order, setOrder] = useState(0);
    const [vies, setVies] = useState(()=> facile ? 6 : 4 );
    const [questions, setQuestions] = useState(() => selectRandomQuestion(leQuizz[0].questions));
    const [IsIncorrect,setIsIncorrect] = useState(false);
    const [GoodAnswer,setGoodAnswer] = useState(false);
    const [gameOver,setGameOver] = useState(false);
    const [gameWin,setGameWin] = useState(false);
    const [counter,setCounter] = useState(10);
    const [nbGood,setNbGood] = useState(0);
    const [indice,setIndice] = useState([]);


    useEffect(() => { 
        setQuestions(() => selectRandomQuestion(leQuizz[order].questions))
      },[order]);


      useEffect(() => { 
        if(GoodAnswer === true){
            const timer = setInterval(() => {
                setCounter((prevCounter)=> prevCounter -1);
            }, 1000);
            return () => clearInterval(timer);
        }else{
            setCounter(10);
        }
      },[GoodAnswer]);


    function selectRandomQuestion(questions){
        let results = [];
        while (results.length < 5){
            const randomIndex = Math.floor(Math.random() * questions.length);
            const randomElement = questions[randomIndex];
            if(!results.includes(randomElement)){
                results.push(randomElement);
            }
        }
        return results;   
    }


    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
      
        return result;
      };
      

    function onDragEnd(result){

    if (!result.destination) {
        return;
      }
  
      const newQuestions = reorder(
        [...questions],
        result.source.index,
        result.destination.index
      );
  
      setQuestions(newQuestions);   

      }
    

     async function validateAnswer(answer){

        let playerAnswer = [];
        let realAnswer = [];
        answer.map((el)=>{
            return playerAnswer.push(el.date);
        })

        questions.map((el)=>{
            realAnswer.push(el.date);
            realAnswer.sort((a,b)=>{
                return a - b;
            });
            return realAnswer;
        })

        let indiceArray=[];
        indiceArray.push('"' + questions.filter(el => el.date == realAnswer[0])[0]["titre"] + '" est placé quelque part avant "' + questions.filter(el => el.date == realAnswer[3])[0]["titre"]+ '"');
        indiceArray.push('"' + questions.filter(el => el.date == realAnswer[3])[0]["titre"] + '" est placé quelque part après "' + questions.filter(el => el.date == realAnswer[1])[0]["titre"]+ '"');
        indiceArray.push('"' + questions.filter(el => el.date == realAnswer[1])[0]["titre"] + '" est positionné juste avant "' + questions.filter(el => el.date == realAnswer[2])[0]["titre"]+ '"');
        indiceArray.push('"' + questions.filter(el => el.date == realAnswer[4])[0]["titre"] + '" est positionné juste après "' + questions.filter(el => el.date == realAnswer[3])[0]["titre"]+ '"');
        indiceArray.push('"' + questions.filter(el => el.date == realAnswer[2])[0]["titre"] + '" est arrivé en ' + questions.filter(el => el.date == realAnswer[2])[0]["date"]);
        indiceArray.push('"' + questions.filter(el => el.date == realAnswer[1])[0]["titre"] + '" est arrivé en ' + questions.filter(el => el.date == realAnswer[1])[0]["date"]);

        setIndice(indiceArray);

        if(JSON.stringify(realAnswer) === JSON.stringify(playerAnswer)){   
            if(order === leQuizz.length - 1){
                setGameWin(true);
            }else{
                setIsIncorrect(false);
                setGoodAnswer(true);
                await delay(10000);
                setGoodAnswer(false);
                setOrder(order + 1);
                facile ? setVies((previousVies)=>previousVies + 4) : setVies((previousVies)=>previousVies + 2);                
            }
        }else{
            if(vies === 1){
                setGameOver(true);
            }else{
            setVies(vies - 1);
            setIsIncorrect(true);
            let count = 0
                for (let index = 0; index < realAnswer.length; index++) {
                    if(playerAnswer[index] === realAnswer[index]){
                        count++
                    }    
                }
                setNbGood(count);  
                setIndice(indiceArray[Math.floor(Math.random() * 6)])
                // setIndice('"' + questions.filter(el => el.date == realAnswer[2])[0]["titre"] + '" est arrivé avant "' + questions.filter(el => el.date == realAnswer[4])[0]["titre"]+ '"');    
            }
        }
    }
    const delay = ms => new Promise(res => setTimeout(res, ms));


  return (

    <div className="game">

    {(!gameOver && !gameWin) &&
    <>
        <div className="header ">
            <h1> Thème : {leQuizz[order].titre}</h1>
            <div className="vies">

                    <motion.span 
                    initial={vies === 4 ? {opacity:1} : {opacity:0}}
                    animate={{opacity:1}}
                    transition={{duration:0.7, ease:'easeIn'}}
                    key={vies}>
                        {[...Array(vies)].map( (el,id) =>
                            <span className='vie' key={id}>❤️</span> 
                        )}
                    </motion.span> 
            </div>
        </div>

    <DragDropContext  onDragEnd={onDragEnd}>
        <Droppable droppableId="questions"  direction={window.innerWidth <= 768 ? 'vertical' : 'horizontal'} >
            {(provided)=> ( 
                <div className='questions' {...provided.droppableProps} ref={provided.innerRef} >
                    <hr className='line'/>
                                    {questions.map((question,index)=> 
                                        <Draggable  key={question.date} draggableId={question.date.toString()} index={index}>
                                        {(provided) => (

                                             <React.Fragment key={question.date}>
                                                <div className='case' ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                    <div className='innercase' style={{'backgroundColor': GoodAnswer ? 'green':''}}>
                                                            {question.titre}
                                                            {GoodAnswer && <p style={{fontWeight: 'bold'}}>{question.date}</p>}
                                                     </div>       
                                                </div>

                                            </React.Fragment>
                                            
                                        )}
                                        
                                        </Draggable>
                                    )}
                                           {provided.placeholder}
                </div>
                
            )}
            
        </Droppable>
    </DragDropContext>


        <div className='footer'> 
        <motion.div 
                    initial={{opacity:0}}
                    animate={ IsIncorrect ? {opacity:1} : {opacity:0} }
                    transition={{duration:0.3, ease:'easeInOut'}}
                    >
            <div className='isIncorrect' >
                <h2 style={{'margin':'0'}}>Réponse incorrect, il y a <span style={{fontSize:'2rem'}}>{nbGood}</span> {nbGood <= 1 && <span>case bien placée</span>}{nbGood >= 2 && <span>cases bien placées</span>}</h2>
                <br />
                <h2 style={{'margin':'0'}}>{nbGood < 3 && vies < 3 && <span style={{fontSize:'1rem', color: 'orange'}}>Indice aléatoire: {indice}</span>}</h2>
            </div>
        </motion.div> 
        <motion.div 
                    initial={{opacity:0}}
                    animate={ GoodAnswer ? {opacity:1} : {opacity:0} }
                    transition={{duration:0.3, ease:'easeInOut'}}
                    >
            <div className='isCorrect'>
                <h2 style={{'margin':'0'}}>Bonne réponse ! Prochain thème dans {counter} secondes...</h2>
            </div>
        </motion.div> 
            <div className="homescreen validate" onClick={() => validateAnswer(questions)}> 
                <h2>Valider</h2>
            </div>
        </div>
    </>
    }

    {(gameWin || gameOver) &&
        <Ending overOrWin={gameWin ? true : false} handlingRestart={handlingRestart}></Ending>
    }

    </div>



  )
}

export default Game